// extracted by mini-css-extract-plugin
export default {"animateBtn":"Button_animateBtn__VCV2N","specialBtn":"Button_specialBtn__syapb"};